import { render, staticRenderFns } from "./ColorPickerTest.vue?vue&type=template&id=4e743784&"
import script from "./ColorPickerTest.vue?vue&type=script&lang=js&"
export * from "./ColorPickerTest.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports